import React from "react";
import Button from '@material-ui/core/Button';
import Progress from "./Progress";
import $ from 'jquery';
import image from "../my_pic.jpg";
const about=()=>{
    function myFunction() {
        // console.log("jdkk");
        var dots = document.getElementById("dots");
        var moreText = document.getElementById("more");
        var btnText = document.getElementById("myBtn");
    
        if (dots.style.display === "none") {
    
          btnText.innerHTML = "Read more";
          // moreText.style.display = "none";
          var s="I have gained a lot through coding in these few years. As a Machine learner I love to apply differnt ML,NLP algorithms to get desired output. I have also created models through Tensorflow and computer vision does helps us in to make excellent image detection."
          let i = s.length;
          console.log(i);
          typeWrite();
          function typeWrite() {
    
            i--;
            document.getElementById("more").value = s.slice(0, i + 1);
            document.getElementById("more").innerHTML = document.getElementById("more").value;
            console.log(document.getElementById("more").value);
            if (i !== -1)
              setTimeout(typeWrite, 50);
            else
              dots.style.display = "inline";
    
          }
          typeWriter()
          function typeWriter() {
    
    
            if (f === 0) {
    
              if (p === 0) {
                document.getElementById("dots").innerHTML += s.charAt(i);
                document.getElementById("dots").style.color = "black";
              }
              if (p === 1 && i !== 0) {
                document.getElementById("dots").innerHTML += s.charAt(i);
    
              }
              i++;
    
              // if(i==s.length )
              // {
              //     f=1;
              // }
              // }
              // else{
    
    
    
            }
            setTimeout(typeWriter, 50);
          }
    
    
        } else {
          dots.style.display = "none";
          btnText.innerHTML = "Read less";
          moreText.style.display = "inline";
          var s="I have gained a lot through coding in these few years. As a Machine learner I love to apply differnt ML,NLP algorithms to get desired output. I have also created models through Tensorflow and computer vision does helps us in to make excellent image detection."
          var i = 0;
          var f = 0;
          var p = 0;
          typeWriter()
          function typeWriter() {
    
    
            if (f === 0) {
    
              if (p === 0) {
                document.getElementById("more").innerHTML += s.charAt(i);
                document.getElementById("more").style.color = "black";
              }
              if (p === 1 && i !== 0) {
                document.getElementById("more").innerHTML += s.charAt(i);
    
              }
              i++;
    
              // if(i==s.length )
              // {
              //     f=1;
              // }
              // }
              // else{
    
    
    
            }
            setTimeout(typeWriter, 50);
          }
        }
      };
      let p=0;
 
      const rightmove=()=>{
        let y=document.getElementById('fig');
          p-=100;
        //   if(p==-500)
        //  p=0;
         y.style.left=`${p}%` ;
         
    
      }
      const leftmove=()=>{
        let y=document.getElementById('fig');
          p+=100;
        //   if(p==-500)
        //  p=0;
         y.style.left=`${p}%` ;
         
    
      }
      // aos.init();
        // AOS.init();
        function call() {
          //   let y=document.querySelector('.whole');
          if (document.querySelector('#load').style.display == "none") {
            $('html').css('overflow-y', 'auto');
            console.log('nio');
          }
        }
    return(
        <>
        <div className="about container-fluid"   id="second" onMouseEnter={() => call()}>
          <div id="about1"><div id="about2" data-aos="zoom-in">About</div></div>
          <div id="info">
          {/* <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img className="d-block w-100" src="..." alt="First slide"/>
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="..." alt="Second slide"/>
    </div>
    <div className="carousel-item">
      <img className="d-block w-100" src="..." alt="Third slide"/>
    </div>
  </div>
  <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="sr-only">Previous</span>
  </a>
  <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="sr-only">Next</span>
  </a>
</div> */}
          {/* <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
              <div className="carousel-inner">
                <div className="carousel-item active"> */}
                <div id="what">
                    <div id="myface" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
                      <img id="face" src={image} alt="my_pic" />
                    </div>
                    <div id="whole" data-aos="fade-left"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
    <div id="slide">
        {/* <div id="left"><div onclick="leftmove()"><</div></div> */}
        <figure id="fig" >
          <div className="lop" >
            <div id="firp">
                      <div id="sefirp" >
                    <div id="para" >
                      <p> Hi, I am Avishake. I am currently pursuing my Btech degree from Academy of Technology. Currently I am in 3rd year.
                    Coding is my passion. I have started coding at the age 15. I love to solve complicated coding problems as it helps me
                    improve my skills. I have also participated in many coding competitions. Coding has helped me to look the world 
                     in a different way. I am also an active member in codechef. I know these languages so much like c,c++,python,
                    Java and octave. Out of these Python is my favourite though it is said to have slow execution time. Apart from coding I have started 
                    focussing on web development and Machine learning(which is trending). As a web developer I have created many web development projects through which we can interact with the user. 
                    <span id="dots">...</span><span id="more"></span></p>
                    </div>
                   
                    <div className="hidden" ><div onClick={rightmove}><i className="fa fa-angle-right"  data-aos="fade-left"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="500"/></div></div>
                    </div>
                   
                    <Button variant="contained" onClick={myFunction} id="myBtn" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom">Read more</Button>

                  </div>
                  </div>
                  <div className="lop" id="selop">
                  <div id="skiii">
                    <div id="skills">
                    <p id="ski" data-aos="fade-up">Skills</p>
                    <Progress 
                    prog="C++"
                    perc="75"/>
                    <Progress 
                    prog="C"
                    perc="80"/>
                   <Progress 
                    prog="Python"
                    perc="85"/>
                    <Progress 
                    prog="Java"
                    perc="78"/>
                    <Progress 
                    prog="HTML"
                    perc="85"/>
                    <Progress 
                    prog="CSS"
                    perc="80"/>
                    <Progress 
                    prog="JavaScript"
                    perc="79"/>
                    <Progress 
                    prog="Numpy"
                    perc="82"/>
                    <Progress 
                    prog="React"
                    perc="80"/>
                    <Progress 
                    prog="NodeJs"
                    perc="60"/>
                  <Progress 
                    prog="Bootstrap"
                    perc="75"/>
                  </div>
                    </div>
                    <div className="hidden" id="leftslip" ><div onClick={leftmove}><i className="fa fa-angle-left"/></div></div>
                    </div>
                  </figure>
        
        {/* <div id="right"><div onclick="rightmove()">></div></div> */}
    </div>
    </div>
</div>
                {/* </div>
                  <div className="carousel-item">
                    <img className="d-block w-100" src="..." alt="Second slide"/>
                  </div>
                    <div className="carousel-item">
                      <img className="d-block w-100" src="..." alt="Third slide"/>
    </div>
                    </div>
                  </div> */}
                  
                  {/* <div id="bio">
                    <h3 class="text-secondary" id="bi">BIO</h3>
                    <table>
                      <tr>
                        <th>Name</th>
                        <td>Avishake Maji</td>
                      </tr>
                      <tr>
                        <th>Age</th>
                        <td>20</td>
                      </tr>
                      <tr>
                        <th>Passion</th>
                        <td>Coding</td>
                      </tr>
                      <tr>
                        <th>School</th>
                        <td>Tribeni Tissues Vidhyapith</td>
                      </tr>
                      <tr>
                        <th>College</th>
                        <td>Academy Of Technology</td>
                      </tr>
                      <tr>
                        <th>Country</th>
                        <td>India</td>
                      </tr>
                    </table>

                  </div>
                  <div id="skills">
                    <p id="ski">Skills</p>
                    <div class="lang">
                      <p>C++ : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: "75%" }}>
                          75%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>C : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: "80%" }}>
                          80%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>Python : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{ width: "85%" }}>
                          85%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>Java : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="78" aria-valuemin="0" aria-valuemax="100" style={{ width: "78%" }}>
                          78%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>HTML : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: "80%" }}>
                          80%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>Css : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: "80%" }}>
                          80%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>JavaScript : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="79" aria-valuemin="0" aria-valuemax="100" style={{ width: "79%" }}>
                          79%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>Numpy : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="82" aria-valuemin="0" aria-valuemax="100" style={{ width: "82%" }}>
                          82%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>ReactJs : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: "80%" }}>
                          80%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>NodeJs : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: "60%" }}>
                          60%
  </div>
                      </div>
                    </div>
                    <div class="lang">
                      <p>Bootstrap : </p>
                      <div class="progress">
                        <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar"
                          aria-valuenow="77" aria-valuemin="0" aria-valuemax="100" style={{ width: "77%" }}>
                          77%
  </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
        </>
    )
}
export default about;
